import { npnValidation, dateValidation, userNameValidation, zipCodeValidation } from '../../common/utilities/CustomValidatorUtil';
import { formatDate } from '../../common/utilities/CustomFormatUtil';
import { fetchVerifyUser } from '../../common/services/proxyServices';

const validationCheck = (inputValidator, inputValue) => {
  switch (inputValidator) {
    case 'npn':
      return npnValidation(inputValue);
    case 'username':
      return userNameValidation(inputValue);
    case 'dateofbirth':
      return dateValidation(inputValue);
    case 'daterange':
      return dateValidation(inputValue, 'daterange');
    case 'riskzip':
      return zipCodeValidation(inputValue);
    default:
      break;
  }
  return null;
};

const handleErrors = (errorCode, setShowBannerType, setIsLicensed, setIsEditable, setIsValid) => {
  switch (errorCode) {
    case 'E100':
    case 'E300':
    case 'E400':
    case 'sso':
      setShowBannerType(errorCode);
      break;
    case 'E200':
      setShowBannerType(errorCode);
      setIsLicensed(true);
      setIsEditable(false);
      setIsValid(false);
      break;
    case 'info':
      setShowBannerType(errorCode);
      setIsEditable(false);
      break;
    default:
      setShowBannerType('E900');
      break;
  }
};

const verifyLicensedData = (licensedData, formValues, setShowBannerType, type, ssoAgent, accountLicensed, domain) => {
    if (!licensedData) {
        return false;
    }

    const userData = licensedData.data?.userData || {};
    let { lastName, npn, userId, dob } = userData;
    let { lastName: formLastName, npn: formNpn, username, dateofbirth } = formValues;
    npn = npn === null || npn === undefined ? '' : npn;
    formNpn = formNpn === null || formNpn === undefined ? '' : formNpn;
    //trim spaces for comparison.
    formLastName = formLastName ? formLastName.trim() : '';
    username = username ? username.trim() : '';        

    const isMatchingNpn = (accountLicensed && npn === '') || (npn === formNpn);
    const isMatchingUserId = userId !== undefined && userId.toLowerCase() === username.toLowerCase();
    const isMatchingDob = formatDate(dob) === formatDate(dateofbirth);
    const isSSO = ssoAgent !== null;
    let isValid = false;

    if (type === 'add') {
      if (isSSO && (!domain || domain.toLowerCase() !== ssoAgent.toLowerCase())) {
        handleErrors('sso', setShowBannerType);
        return false;
      }
      const isMatchingName =  (lastName && formLastName) ? lastName.toLowerCase() === formLastName.toLowerCase() : false;        
      isValid = isMatchingName && isMatchingNpn && isMatchingUserId && isMatchingDob;
    } else {
        isValid = isMatchingNpn && isMatchingUserId && isMatchingDob;
    }

    if (isValid) {
        return true;
    } 
    
    handleErrors('E300', setShowBannerType);
    return false;
    
};


const handleValidateAgent = (formValues, history, setIsLoading, setShowBannerType, setIsLicensed, setLicensedData, setIsEditable, setIsValid, isLicensed) => {
  setIsLoading(true);
  setTimeout(() => {
    fetchVerifyUser(formValues)
      .then(async (data) => {
        if (isLicensed && data?.data?.userData?.npn === '') {
          data.errorCode = 'info';
        }
        await setLicensedData(data);
        if(data.canEnroll && (data.errorCode === '' || data.errorCode === 'INFO')) {
          return;
        }
        const error = new Error(data.errorCode);
        error.data = data.canEnroll;
        throw error;
      })
      .catch((error) => {
        handleErrors(error.message, setShowBannerType, setIsLicensed, setIsEditable, setIsValid);
      })
      .finally(() => {
        window.scroll(0, 0);
        setIsLoading(false);
      });
  }, 2000);
};

export { validationCheck, handleErrors, handleValidateAgent, verifyLicensedData };